import { IFormValues } from './interfaces/IFormValues';
import { convertFormValuesToRequest } from './convertFormValuesToRequest';
import { APIFactory } from '../../../../../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../../../../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../../../../ui-toolkit/rest/BaseUrlService';
import { IEscrowWireDisbursement } from './interfaces/IEscrowWireDisbursement';

export const createWireFromACHPushAsync = async (values: IFormValues) => {
  const requestData = convertFormValuesToRequest(values);
  return APIFactory(baseUrlService.ApiLocation)
    .post<IEscrowWireDisbursement>(
      '/timber/api/internal/escrow/wire_disbursement/create_wire_from_ach_push',
      requestData
    )
    .then(() => ({
      payload: true,
    }))
    .catch(axiosErrorHandler);
};
